<template>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="已有库" name="first" >
                <el-row :span="24">
                    <el-col  :span="8">
                        <el-card :body-style="{ padding: '0px' }">
                            <div style="padding: 14px;">
                                <span>好吃的汉堡</span>

                                <el-button type="primary" circle size="mini">来源</el-button>
                                <el-button type="success" circle size="mini">目标</el-button>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col  :span="8">
                        <el-card :body-style="{ padding: '0px' }">
                            <div style="padding: 14px;">
                                <span>好吃的汉堡</span>
                                <el-button type="primary" circle size="mini">来源</el-button>
                                <el-button type="success" circle size="mini">目标</el-button>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col  :span="8">
                        <el-card :body-style="{ padding: '0px' }">
                            <div style="padding: 14px;">
                                <span>好吃的汉堡</span>
                                <el-button type="primary" circle size="mini">来源</el-button>
                                <el-button type="success" circle size="mini">目标</el-button>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="自定义" name="second">配置管理</el-tab-pane>
        </el-tabs>
        <el-row style="text-align:left">
          <el-col>
              <el-button type="primary">加载表</el-button>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="4">
                <el-card class="box-card">
                    <div v-for="o in 4" :key="o" class="text item">
                        {{'列表内容 ' + o }}
                    </div>
                </el-card>
            </el-col>
            <el-col :span="20">
                <el-collapse v-model="activeNames" >
                    <el-collapse-item title="列信息" name="1">
                        <el-table
                                :data="tableData"
                                style="width: 100%">
                            <el-table-column
                                    fixed
                                    prop="name"
                                    label="列名">
                            </el-table-column>
                            <el-table-column
                                    prop="province"
                                    label="数据类型">
                            </el-table-column>
                            <el-table-column
                                    prop="province"
                                    label="长度"
                                    width="120">
                            </el-table-column>
                            <el-table-column
                                    prop="province"
                                    label="精确度">
                            </el-table-column>
                            <el-table-column
                                    prop="province"
                                    label="主键">
                            </el-table-column>
                            <el-table-column
                                    prop="city"
                                    label="可空">
                            </el-table-column>
                            <el-table-column
                                    prop="city"
                                    label="默认值">
                            </el-table-column>
                            <el-table-column
                                    prop="address"
                                    label="备注">
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>
                    <el-collapse-item title="索引信息" name="2">
                    </el-collapse-item>
                    <el-collapse-item title="外键信息" name="3">

                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>
    </div>
</template>
<style>
    .text {
        font-size: 14px;
    }

    .item {
        padding: 18px 0;
    }

    .box-card {
    }
</style>
<script>
    export default {
        data() {
            return {
                activeName:'first',
                activeNames:["1","2","3"],
                tableData: [{
                    date: '2016-05-03',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-02',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-08',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-06',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-07',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }]
            }
        },
        methods: {
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            handleChange(val) {
                console.log(val);
            }
        }
    }
</script>